import { render, staticRenderFns } from "./editSaleItemsComponent.vue?vue&type=template&id=164e05cd&"
import script from "./editSaleItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./editSaleItemsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports